import React, { ReactNode, useEffect, useRef, JSX, forwardRef, useImperativeHandle } from 'react';
import { Transformer } from 'markmap-lib';
import { Markmap } from 'markmap-view';
import 'markmap-toolbar/dist/style.css';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import './index.scss';
import AIMarks from '../AiMark';
type Props = {
    content: string;
    toolbarSlot?: JSX.Element | ReactNode;
    showOperator?: boolean;
    className?: string;
    rootClassName?: string;
    zoom?: boolean;
    autoFit?: boolean;
    maxScale?: number;
    minScale?: number;
};
type MarkMapRef = {
    markMapObj?: Markmap | null;
    zoomPlus?: () => void;
    zoomMinus?: () => void;
};
const MarkMap = (
    { content, toolbarSlot, showOperator, className = '', rootClassName = '', maxScale = 5, minScale = 0.4, zoom = false, autoFit = true }: Props,
    ref: React.Ref<MarkMapRef>
) => {
    const refSvg = useRef<SVGSVGElement>(null);
    const refMm = useRef<Markmap>(null);
    const transformer = new Transformer();
    useEffect(() => {
        if (!refSvg.current) return;
        // Update data for markMap once value is changed
        const mm = Markmap.create(refSvg.current, { zoom, autoFit });
        //@ts-ignore
        refMm.current = mm;
        if (!mm || !content) return;
        const { root } = transformer.transform(content);
        mm?.setData(root);
        mm?.fit();
    }, [content]);
    useEffect(() => {
        return () => {
            refMm.current?.destroy();
        };
    }, []);
    const zoomPlus = () => {
        const g = refSvg.current?.querySelector('g');
        if (g && g.getAttribute('transform')) {
            let style = window.getComputedStyle(g);
            let matrix = new WebKitCSSMatrix(style.transform);
            if (maxScale && matrix.a >= maxScale) return false;
        }
        refMm.current?.rescale(1.2);
    };
    const zoomMinus = () => {
        const g = refSvg.current?.querySelector('g');
        if (g && g.getAttribute('transform')) {
            let style = window.getComputedStyle(g);
            let matrix = new WebKitCSSMatrix(style.transform);
            if (minScale && matrix.a <= minScale) return false;
        }
        refMm.current?.rescale(0.8);
    };
    useImperativeHandle(ref, () => {
        return {
            markMapObj: refMm.current,
            zoomPlus,
            zoomMinus
        };
    });
    return (
        <div className={'mark-map-user' + (' ' + rootClassName || '')}>
            <div className={'mark-map-user-toolbar'}>
                {toolbarSlot ? toolbarSlot : null}
                {!showOperator ? null : (
                    <div className={'mark-map-user-toolbar-content'}>
                        <PlusCircleOutlined className={'zoom-icon-in'} onClick={zoomPlus} />
                        <MinusCircleOutlined className={'zoom-icon-out'} onClick={zoomMinus} />
                    </div>
                )}
            </div>
            <svg className={'flex-1' + (' ' + className || '')} ref={refSvg} />
            <AIMarks index={1} size="14" style={{ color: '#BFBFBF', textAlign: 'right' }} />
        </div>
    );
};
export default forwardRef(MarkMap);
